import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyContactBar from "@/components/StickyContactBar";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import ServiceCityCombo from "@/pages/ServiceCityCombo";
import Cities from "@/pages/Cities";
import CityDetail from "@/pages/CityDetail";
import NeighborhoodDetail from "@/pages/NeighborhoodDetail";
import Sectors from "@/pages/Sectors";
import SectorDetail from "@/pages/SectorDetail";
import Playbook from "@/pages/Playbook";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Regions from "@/pages/Regions";
import RegionDetail from "@/pages/RegionDetail";
import NotFound from "@/pages/NotFound";
import useLenis from "@/hooks/useLenis";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  useLenis();
  return (
    <div className="App grain min-h-screen bg-[#050505] text-white">
      <Nav />
      <ScrollToTop />
      <main data-testid="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route
            path="/services/:serviceSlug/:citySlug"
            element={<ServiceCityCombo />}
          />
          <Route path="/cities" element={<Cities />} />
          <Route path="/cities/:slug" element={<CityDetail />} />
          <Route
            path="/cities/:citySlug/:neighborhoodSlug"
            element={<NeighborhoodDetail />}
          />
          <Route path="/sectors" element={<Sectors />} />
          <Route path="/sectors/:slug" element={<SectorDetail />} />
          <Route path="/playbook" element={<Playbook />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/regions" element={<Regions />} />
          <Route path="/regions/:slug" element={<RegionDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <StickyContactBar />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
